import React from 'react'
import FormField from 'components/UI/AsideModal/Form/FormField'
import FormLabel from 'components/UI/AsideModal/Form/FormLabel'
import FormInput from 'components/UI/AsideModal/Form/FormInput'
import FormFieldset from 'components/UI/AsideModal/Form/FormFieldset'
import asideModalStore from 'Stores/asideModalStore'
import SelectCustom from 'components/ContentBox/Global/Select/SelectCustom'

import st from './AddingPersonalTestResultsModal.module.scss'
import { observer } from 'mobx-react'
import FormDateSelector from 'components/UI/AsideModal/Form/FormDateSelector'
import { dateFormat } from 'helpers/date'
import TextareaMarkup from 'components/UI/TextareaMarkup/TextareaMarkup'

const AddingPersonalTestResultsModal = ({
  categories,
  students,
  isSmallForm,
}) => {
  const {
    modalValues: modalValue,
    changeValue: changeValues,
    check,
  } = asideModalStore

  const handleCommentChange = (e) => {
    if (isSmallForm) {
      changeValues(e.target.value, 'employee_comment')
    } else {
      changeValues(e.target.value, 'description')
    }
  }

  return (
    <FormFieldset>
      {!isSmallForm && (
        <>
          <div className={st.field}>
            <FormField>
              <FormLabel isRequired>{'Select a student'}: </FormLabel>
              <FormInput isError={check('student')}>
                <SelectCustom
                  placeholder={'Select a student'}
                  options={students}
                  sortKey='student'
                  optionLabelKey={'full_name'}
                  valueID={modalValue?.student}
                  onChange={(o) => changeValues(o?.id, 'student')}
                  error={check('student')}
                />
              </FormInput>
            </FormField>
          </div>
          <div className={st.twoColumns}>
            <FormField>
              <FormLabel isRequired>{'Select categories'}: </FormLabel>
              <SelectCustom
                placeholder={'Select categories'}
                options={categories.filter((category) => {
                  const name = category.name.trim().toLowerCase()
                  return !name.includes('juniors')
                })}
                sortKey='category'
                optionValueKey={'name'}
                valueID={modalValue?.category || ''}
                onChange={(o) => changeValues(o?.value, 'category')}
                isSearchable
                error={check('category')}
              />
            </FormField>
            <FormField>
              <FormLabel isRequired>{'Percentage'}: </FormLabel>
              <FormInput isError={check('test_scores')}>
                <input
                  className={st.inputForNumber}
                  placeholder={'Percentage'}
                  value={modalValue?.test_scores || ''}
                  onChange={(e) => {
                    let value = e.target.value
                    value = value.replace(/[^0-9]/g, '')
                    const numericValue = value !== '' ? Number(value) : ''
                    if (
                      numericValue === '' ||
                      (numericValue >= 0 && numericValue <= 100)
                    ) {
                      changeValues(numericValue, 'test_scores')
                    }
                  }}
                  onBlur={(e) => {
                    let value = e.target.value ? Number(e.target.value) : 0
                    if (value < 0) value = 0
                    if (value > 100) value = 100
                    changeValues(value, 'test_scores')
                  }}
                />
              </FormInput>
            </FormField>
          </div>
          <div className={st.twoColumns}>
            <FormField>
              <FormLabel isRequired>{'Test name'}: </FormLabel>
              <FormInput isError={check('test')}>
                <input
                  placeholder={'Test name'}
                  type='text'
                  value={modalValue?.test || ''}
                  onChange={(e) => changeValues(e.target.value, 'test')}
                />
              </FormInput>
            </FormField>

            <FormDateSelector
              isRequired={true}
              placeholder='Test Date'
              label='Test Date'
              onChange={(val) =>
                changeValues(dateFormat(val, 'YYYY-mm-dd'), 'date')
              }
              value={modalValue?.date || ''}
              error={check('date')}
            />
          </div>
        </>
      )}
      <FormField>
        <FormLabel isRequired={isSmallForm}>Comment:</FormLabel>
        <FormInput isError={check('employee_comment')}>
          <TextareaMarkup
            placeholder='Comment'
            value={
              isSmallForm
                ? modalValue?.employee_comment || ''
                : modalValue?.description || ''
            }
            stateName={isSmallForm ? 'employee_comment' : 'description'}
            onChange={changeValues}
            error={check(isSmallForm ? 'employee_comment' : 'description')}
          />
        </FormInput>
      </FormField>
    </FormFieldset>
  )
}

export default observer(AddingPersonalTestResultsModal)
